import React, { createContext } from 'react';
import type { StockCarOutput } from '../../types';
import useStockCarDetails from '../../hooks/useStockCarDetails';

const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
const vehicleId = new URLSearchParams(locationSearch).get('vehicleId');
const market = new URLSearchParams(locationSearch).get('market') ?? 'us';

interface VehicleProviderProps {
  children: React.ReactNode;
  oaddDealerId: string;
  isTier3?: boolean;
}

// This is injected to the application at root level, context will always have a value
export const vehicleContext = createContext<StockCarOutput>({} as StockCarOutput);
const { Provider } = vehicleContext;

const VehicleProvider: React.FC<VehicleProviderProps> = ({ children, oaddDealerId, isTier3 }) => {
  const vehicleInfo = useStockCarDetails(vehicleId, market, isTier3);
  const vehicleBag: StockCarOutput = {
    ...vehicleInfo,
    oaddDealerId,
  };

  return <Provider value={vehicleBag}>{children}</Provider>;
};

export default VehicleProvider;
